export default {
  getShipmentPaymentParams: (_state: any) => _state.shipmentPaymentInformation,
  getPaymentScheduleParams: (_state: any) => _state.paymentScheduleInformation,
  getDiscountParams: (_state: any) => _state.discountInformation,
  getCreditLimitParams: (_state: any) => _state.creditLimitInformation
}
